// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  allProjectsButton: {
    // The crumb is a word, not a control: no hover plate behind it.
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  allProjectsText: {
    textTransform: 'none',
  },
  // The trailing crumb's type, defined once here so whatever a caller puts in it - the folder
  // page's editable name, the map rail's plain label - reads identically.
  currentCrumb: {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '1rem',
    fontWeight: 500,
    color: theme.palette.darkGrey,
  },
});

export default styles;
